{
    "BroadworksProvisioningHeader": "Provisioning",
    "BroadworksProvisioningTableHeaderEnabled": "Ingeschakeld",
    "BroadworksProvisioningTableHeaderItem": "Item",
    "BroadworksProvisioningTableHeaderServicePack": "Servicemelding:",
    "BroadworksProvisioningTableHeaderTelephonyServers": "Telefonie Server(s)",
    "BroadworksProvisioningAddEntry": "Invoer toevoegen...",
    "BroadworksProvisioningItemExtension": "Verlenging",
    "BroadworksProvisioningItemHospitality": "Gastvrijheid",
    "BroadworksProvisioningItemAcdAgent": "ACD-agent",
    "BroadworksProvisioningButtonDiscardChanges": "Veranderingen ongedaan maken",
    "BroadworksProvisioningButtonSave": "Opslaan",
    "BroadworksProvisioningButtonActions": "Acties",
    "BroadworksProvisioningButtonDelete": "Verwijderen",
    "BroadworksProvisioningButtonEdit": "Bewerk",
    "BroadworksProvisioningValueIsRequired": "Waarde is vereist.",
    "NAME": "Provisioning",
    "BroadworksProvisioningTableHeaderSendWelcomeEmail": "Welkomstmail versturen",
    "BroadworksProvisioningItemEssentials": "Benodigdheden",
    "BroadworksProvisioningItemProfessional": "Professioneel",
    "BroadworksProvisioningItemCallCentreAgent": "Callcenter Agent",
    "BroadworksProvisioningItemEnterprise": "Onderneming",
    "BroadworksProvisioningItemCallCentreSupervisor": "Supervisor callcenter",
    "BroadworksProvisioningItem1000": "Akixi 1000",
    "BroadworksProvisioningItem2000": "Akixi 2000"
}